export const PRODUCTION_CONSUMER_API_URL = "https://api.lightningflow.ai";

export function resolveConsumerApiBaseUrl(
  env = process.env,
  { allowHttpLoopback = process.env.NODE_ENV === "test" } = {},
) {
  const raw = String(env.REACT_APP_CONSUMER_API_URL || "").trim().replace(/\/+$/, "");
  if (!raw) {
    throw new Error("REACT_APP_CONSUMER_API_URL is required for the customer API client");
  }
  let parsed;
  try {
    parsed = new URL(raw);
  } catch {
    throw new Error("REACT_APP_CONSUMER_API_URL must be an absolute URL");
  }
  const isLoopbackHttp =
    parsed.protocol === "http:" &&
    (parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost");
  if (parsed.protocol === "https:") {
    if (env.NODE_ENV === "production" && raw !== PRODUCTION_CONSUMER_API_URL) {
      throw new Error(
        `REACT_APP_CONSUMER_API_URL must be ${PRODUCTION_CONSUMER_API_URL} in production builds`,
      );
    }
    return raw;
  }
  if (allowHttpLoopback && isLoopbackHttp) {
    return raw;
  }
  throw new Error("REACT_APP_CONSUMER_API_URL must use HTTPS (http://127.0.0.1 allowed in tests only)");
}
